import applications from "./applications.json";
import application from "./application.json";

export default {
  direct_apply: {
    ...applications,
    ...application,
  },
};
